import React, { useState, useEffect } from "react";

const PingDialog = ({ visible, onHide, pong, setDialogPingVisible }) => {
  const [loading, setLoading] = useState(true);
  const [autoClose, setAutoClose] = useState(false);

  useEffect(() => {
    if (visible) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [visible]);

  useEffect(() => {
    if (!loading && pong) {
      const timer = setTimeout(() => {
        onHide();
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [loading, pong, onHide]);

  if (!visible) return null;

  return (
    <div className="modal fade show" aria-labelledby="pingStatusModal" aria-hidden="true" style={{ display: "block" }}>
      <div className="modal-dialog custom-width modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header dialog-modal">
            <h5 className="modal-title dialog-modal" id="pingStatusModal">Ping Status</h5>
          </div>
          <div className="modal-body-dialog custom-height text-center">
            {loading ? (
              <>
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-3">Connecting...</p>
              </>
            ) : (
              <div>
                {pong ? (
                  <span className="text-success">
                    <i className="fas fa-check-circle"></i> Connected
                  </span>
                ) : (
                  <span className="text-danger dialog">
                    <i className="fas fa-times-circle"></i> Requirements to run the application are missing or not connecting
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PingDialog;
